import React, { useState, useEffect } from "react";
import { FormInput, FormSelect, Row, Col, Button } from "shards-react";
import baseUrl from "config/baseUrl";
import useToken from "shared/hook/useToken";
import styled from "styled-components";
import dayjs from "dayjs";
import "dayjs/locale/es";

const Table34 = (props) => {
  const { token } = useToken();
  const [loading, setLoading] = useState(false);
  const [onEditCurrent, setOnEditCurrent] = useState(
    props.type === "edit" ? false : true
  );
  const [PowerbiData, setPowerbiData] = useState(null);
  const [previousData, setPreviousData] = useState(null);
  const [fundList, setFund] = useState(null);
  const [projectList, setProject] = useState(null);
  const [projectownerList, setProjectowner] = useState(null);
  const [projectstatusList, setProjectstatus] = useState(null);
  const [projecttypeList, setProjecttype] = useState(null);
  const [sourcefundList, setSourcefund] = useState(null);

  const formatDate = (date) => {
    if(date != null){
      const split = date.replace("T"," ").replace(".000Z","").split(" ");
      const splitYear = split[0].split("-");
      console.log("formatDate",`${Number(splitYear[0])-543}-${splitYear[1]}-${splitYear[2]}T${split[1]}`);
      return `${Number(splitYear[0])-543}-${splitYear[1]}-${splitYear[2]}T${split[1]}`;
    }
    return null;
  };

  const formatDateSend = (date) => {
    if(date != null){
      const split = date.replace("T"," ").split(" ");
      const splitYear = split[0].split("-");
      console.log("formatDate",`${Number(splitYear[0])+543}-${splitYear[1]}-${splitYear[2]}T${split[1]}.000Z`);
      return `${Number(splitYear[0])+543}-${splitYear[1]}-${splitYear[2]}T${split[1]}.000Z`;
    }
    return null;
  };


  // 2022-06-27T14:28
  
  // const formatDate = (date) => {
  //   if(date != null){
  //     return date.replace(".000Z","");
  //   }
  //   return null;
  // };

  const axios = require("axios").default;
  //4 สร้างข้อมูลเพื่อส่งไปอนุมัติ
  const onCeateTable = () => {
    const obj = [];
    PowerbiData.map((item, index) => {
      const data = { ...item };
      data.yearId = props.yearId;
      data.dayBegin = formatDateSend(item.dayBegin);
      data.dayFinsh = formatDateSend(item.dayFinsh);
      delete data.id;
      delete data.createDate;
      delete data.lastUpdate;
      delete data.tableHeadId;
      delete data.id;
      obj.push(data);
    });
    console.log("onCeateTable", obj);
    const filter = obj.filter((item) => item.fillValue === "" || item.fillValue === null || item.dayBegin === "" || item.dayFinsh === "" ||  item.dayBegin === null || item.dayFinsh === null);
    console.log("@PowerbiData", filter);
    if (filter.length > 0) {
      alert("กรุณากรอกข้อมูลให้ครบถ้วน");
      return false;
    }
    props.onCeateTable(obj);
  };

  const getCurrentData = () => {
    setLoading(true);
    let data = JSON.stringify({
      params: {
        indicatorsDatasetSettingId: props.indicatorsDatasetSettingId,
        tableTabSettingId: props.tableTabSettingId || null,
        tableHeadId: props.listheadId || null,
        yearNo: props.newHeadId ? null : Number(props.yearNo),
      },
      show: 1,
      page: 1,
      orderBy: "id",
      orderType: "desc",
    });

    var configData = {
      method: "post",
      url: `${baseUrl}/v1/setting-table/listhead`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(configData)
      .then(function(response) {
        if (response.data.data.length > 0) {

          console.log("dataView", response.data.data)
          if (response.data.data[0].list.length == 0) {
            getNewData();
          } else {
            const dataView = response.data.data[0].list.map((item) => {
              let data = { ...item };
                data.dayBegin = formatDate(item.dayBegin);
                data.dayFinsh = formatDate(item.dayFinsh);
                
              if (props.type === "new" && props.newHeadId) {
                if (response.data.data[0].yearId != props.yearId) {
                  data.dayBegin =  "";
                  data.dayFinsh =  "";
                  data.fillValue = "";
                }
              }

              return data;
            });

            console.log("dataView", dataView)
            setLoading(false);
            setPowerbiData(dataView);
          }
        } else {
          setLoading(false);
          setPowerbiData(null);
        }
      })
      .catch(function(error) {
        setLoading(false);
        console.log(
          `v1/setting-table/listhead ${props.indicatorsDatasetSettingId}`,
          error
        );
      });
  };

  const getNewData = () => {
    setLoading(true);
    let data = JSON.stringify({
      params: {
        indicatorsDatasetSettingId: props.indicatorsDatasetSettingId,
        tableTabSettingId: props.tableTabSettingId,
      },
      show: 1,
      page: 1,
      orderBy: "id",
      orderType: "desc",
    });

    var configData = {
      method: "post",
      url: `${baseUrl}/v1/setting-table/listhead`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(configData)
      .then(function(response) {
        setLoading(false);
        if (response.data.data.length > 0) {
          const dataView = response.data.data[0].list.map((item) => {
            let data = { ...item };
            data.dayBegin = "";
            data.dayFinsh = "";
            data.fillValue = "";
            return data;
          });
          setPowerbiData(dataView);
        } else {
          setPowerbiData(null);
        }
      })
      .catch(function(error) {
        setLoading(false);
        console.log(
          `v1/setting-table/listhead ${props.indicatorsDatasetSettingId}`,
          error
        );
      });
  };

  const getFund = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table34/table34fund`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        setFund(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table34/table34fund", error);
      });
  };

  const getProject = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table34/table34project`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        setProject(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table34/table34project", error);
      });
  };

  const getProjectowner = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table34/table34projectowner`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        setProjectowner(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table34/table34projectowner", error);
      });
  };

  const getProjectstatus = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table34/table34projectstatus`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        setProjectstatus(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table34/table34projectstatus", error);
      });
  };

  const getProjecttype = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table34/table34projecttype`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        console.log("setType", response.data);
        setProjecttype(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table34/table34projecttype", error);
      });
  };

  const getSourcefund = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table34/table34sourcefund`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        setSourcefund(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table34/table34sourcefund", error);
      });
  };

  useEffect(() => {
    getFund();
    getProject();
    getProjectowner();
    getProjectstatus();
    getProjecttype();
    getSourcefund();

    getCurrentData();
  }, []);

  useEffect(() => {
    getCurrentData();
  }, [props.yearId]);

  const onAddRowTable = () => {
    let datas = [...PowerbiData];
    const data = { ...datas[0] };
    data.fillValue = "";
    data.growth = "";
    setPowerbiData(datas.concat([data]));
  };

  const onSetdataCost = (index, value) => {
    const newTodos = [...PowerbiData];
    newTodos[index].fillValue = value;
    setPowerbiData(newTodos);
  };

  const onSetdata = (index, dataName, value) => {
    const newTodos = [...PowerbiData];
    newTodos[index][dataName] = value;
    setPowerbiData(newTodos);
  };

  return (
    <Row>
      <Col md="12" style={{ padding: "15px" }}>
        <h5 style={{ float: "left" }}>
          จำนวนข้อมูลทั้งหมด {PowerbiData != null ? PowerbiData.length : 0} แถว
        </h5>

        {props.type === "edit" ? (
          onEditCurrent && (
            <Button
              theme="success"
              onClick={() => onAddRowTable()}
              style={{ float: "right", width: 200 }}
            >
              เพิ่มแถว
            </Button>
          )
        ) : (
          <Button
            theme="success"
            onClick={() => onAddRowTable()}
            style={{ float: "right", width: 200 }}
          >
            เพิ่มแถว
          </Button>
        )}
      </Col>
      <Col
        md="12"
        style={{
          overflowX: "auto",
          display: "block",
        }}
      >
        <table className="table mb-0">
          <thead className="thead-dark">
            <tr>
              <th scope="col">NO</th>
              <th scope="col">Project</th>
              <th scope="col">Project_Owner</th>
              <th scope="col">Fund</th>
              <th scope="col">Project_Type </th>
              <th scope="col">Source_Fund </th>
              <th scope="col"> Value_Fund </th>
              <th scope="col">Project_Status </th>
              <th scope="col">Day_Begin </th>
              <th scope="col">Day_Finish </th>
            </tr>
          </thead>
          {loading ? (
            <tbody className="table-middle">
              <tr>
                <td colSpan={11}> Loading... </td>
              </tr>
            </tbody>
          ) : PowerbiData != null && PowerbiData.length > 0 ? (
            <tbody className="table-middle">
              {PowerbiData.map((item, index) => (
                <tr>
                  <td>{index + 1}</td>
                  <td>
                    <FormSelect
                      placeholder="- เลือก -"
                      value={item.projectId}
                      disabled={!onEditCurrent}
                      onChange={(e) => {
                        onSetdata(index, "projectId", e.target.value);
                      }}
                      require
                    >
                      {projectList != null &&
                        projectList.length > 0 &&
                        projectList.map((item) => {
                          return (
                            <option value={item.projectId}>
                              {item.projectCode} - {item.projectName}
                            </option>
                          );
                        })}
                    </FormSelect>
                  </td>
                  <td>
                    <FormSelect
                      placeholder="- เลือก -"
                      value={item.projectOwnerId}
                      disabled={!onEditCurrent}
                      onChange={(e) => {
                        onSetdata(index, "projectOwnerId", e.target.value);
                      }}
                      require
                    >
                      {projectownerList != null &&
                        projectownerList.length > 0 &&
                        projectownerList.map((item) => {
                          return (
                            <option value={item.projectOwnerId}>
                              {item.projectOwnerName}
                            </option>
                          );
                        })}
                    </FormSelect>
                  </td>
                  <td>
                    <FormSelect
                      placeholder="- เลือก -"
                      value={item.fundId}
                      disabled={!onEditCurrent}
                      onChange={(e) => {
                        onSetdata(index, "fundId", e.target.value);
                      }}
                      require
                    >
                      {fundList != null &&
                        fundList.length > 0 &&
                        fundList.map((item) => {
                          return (
                            <option value={item.fundId}>
                              {item.fundName}
                            </option>
                          );
                        })}
                    </FormSelect>
                  </td>
                  <td>
                    <FormSelect
                      placeholder="- เลือก -"
                      value={item.projectTypeId}
                      disabled={!onEditCurrent}
                      onChange={(e) => {
                        onSetdata(index, "projectTypeId", e.target.value);
                      }}
                      require
                    >
                      {projecttypeList != null &&
                        projecttypeList.length > 0 &&
                        projecttypeList.map((item) => {
                          return (
                            <option value={item.projectTypeId}>
                              {item.projectTypeName}
                            </option>
                          );
                        })}
                    </FormSelect>
                  </td>
                  <td>
                    <FormSelect
                      placeholder="- เลือก -"
                      value={item.sourceFundId}
                      disabled={!onEditCurrent}
                      onChange={(e) => {
                        onSetdata(index, "sourceFundId", e.target.value);
                      }}
                      require
                    >
                      {sourcefundList != null &&
                        sourcefundList.length > 0 &&
                        sourcefundList.map((item) => {
                          return (
                            <option value={item.sourceFundId}>
                              {item.sourceFundName}
                            </option>
                          );
                        })}
                    </FormSelect>
                  </td>
                  <td>
                    <FormInput
                      type="number"
                      value={item.fillValue}
                      disabled={!onEditCurrent}
                      placeholder="fillValue"
                      onChange={(e) => {
                        onSetdata(index, "fillValue", e.target.value);
                      }}
                      require
                    />
                  </td>
                  <td>
                    <FormSelect
                      placeholder="- เลือก -"
                      value={item.projectStatusId}
                      disabled={!onEditCurrent}
                      onChange={(e) => {
                        onSetdata(index, "projectStatusId", e.target.value);
                      }}
                      require
                    >
                      {projectstatusList != null &&
                        projectstatusList.length > 0 &&
                        projectstatusList.map((item) => {
                          return (
                            <option value={item.projectStatusId}>
                              {item.projectStatusName}
                            </option>
                          );
                        })}
                    </FormSelect>
                  </td>
                  <td>
                    {console.log("item.dayBegin",item.dayBegin)}
                    <FormInput
                      type="datetime-local"
                      value={item.dayBegin}
                      disabled={!onEditCurrent}
                      placeholder="dayBegin"
                      onChange={(e) => {
                        onSetdata(index, "dayBegin", e.target.value);
                      }}
                      require
                    />
                  </td>
                  <td>
                    <FormInput
                      type="datetime-local"
                      value={item.dayFinsh}
                      disabled={!onEditCurrent}
                      placeholder="dayFinsh"
                      onChange={(e) => {
                        onSetdata(index, "dayFinsh", e.target.value);
                      }}
                      require
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          ) : (
            <tbody className="table-middle">
              <tr>
                <td colSpan={11}> ไม่มีข้อมูล </td>
              </tr>
            </tbody>
          )}
        </table>
      </Col>

      {props.type === "edit" ? (
        <Col md="12" style={{ padding: "15px" }}>
          {onEditCurrent ? (
            <Button
              theme="success"
              onClick={() => onCeateTable()}
              style={{ float: "right", width: 200 }}
            >
              บันทึกข้อมูล
            </Button>
          ) : props.status == 0 && props.userType != 3 ? (
            <Button
              theme="success"
              onClick={() => props.onApproveTable()}
              style={{ float: "right", width: 200 }}
            >
              อนุมัติเผยแพร่
            </Button>
          ) : null}
          {!onEditCurrent && (
            <Button
              outline
              theme="secondary"
              onClick={() => setOnEditCurrent(true)}
              style={{ float: "right", width: 200, marginRight: 20 }}
            >
              แก้ไขข้อมูล
            </Button>
          )}
        </Col>
      ) : (
        <Col md="12" style={{ padding: "15px" }}>
          <Button
            theme="success"
            onClick={() => onCeateTable()}
            style={{ float: "right", width: 200 }}
          >
            บันทึกข้อมูล
          </Button>
        </Col>
      )}
    </Row>
  );
};

export default Table34;
